import * as types from '../mutation-types';

export default {
	namespaced: true,

	state: {
		lockVisitAfterDuration: null,
		serverTime: null
	},

	actions: {
		fetchConfig({ commit }) {
			return window.axios.get('/Configuration').then(({ data }) => {
				const lockVisitAfterDuration = data.find(c => c.key === 'LockVisitAfterDuration')
				console.log(lockVisitAfterDuration, 'lockVisitAfterDuration')
				commit(types.STORE_LOCK_VISIT_AFTER_DURATION, lockVisitAfterDuration);
				console.log('lockVisitAfterDuration', lockVisitAfterDuration)
				return data
			})
		},

		fetchCurrentTime({ commit }) {
			return window.axios.get('/currentTime').then(({ data }) => {
				commit(types.STORE_SERVER_TIME, data)
				return data
			})
		}
	},

	mutations: {
		[types.STORE_LOCK_VISIT_AFTER_DURATION](state, lockVisitAfterDuration) {
			state.lockVisitAfterDuration = lockVisitAfterDuration
		},

		[types.STORE_SERVER_TIME](state, serverTime) {
			state.serverTime = serverTime
		}
	},

	getters: {},
}